import * as actionTypes from '../actions/actionTypes';

const intiData = {
  activeTabId: 0,
  tabEnabled: false,
  activeTabEnabled: false,
};

export default function activeTabReducer(state = intiData, action) {
  switch (action.type) {
    case actionTypes.ACTIVE_TAB:
      let newState = { ...state };
      if (action.index === 2) { newState.tabEnabled = true;newState.activeTabEnabled=true }
      if (action.index === 3) { newState.activeTabEnabled = true }
      return newState;

    case actionTypes.DISABLE_ADMIN_CASEBODY_TABS:
      return intiData;

    case actionTypes.GO_TO_TAB:
      let newData = { ...state };
      newData.activeTabId = action.index;
      return newData;

    default: return state;

  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/reducers/activeTabReducer.js